import { useEffect, useState } from "react";

import { Box, LinearProgress, Skeleton, Typography } from "@mui/material";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";

import { IDisponibilidadeVagas } from "interfaces/disponibilidadeVagas";
import { IDistanciaEvento } from "interfaces/eventos";
import { checkDisponibilidadeInscricao } from "services/evento";

import {
  INSCRITOS_ACCENT,
  INSCRITOS_ACCENT_SOFT,
} from "../lista-inscritos.theme";

interface Props {
  eventoId: number;
  distancia: IDistanciaEvento;
}

export default function CardListCat({ eventoId, distancia }: Props) {
  const [loading, setLoading] = useState(true);
  const [disponibilidade, setDisponibilidade] = useState<IDisponibilidadeVagas>(
    {} as IDisponibilidadeVagas,
  );

  useEffect(() => {
    let ativo = true;
    setLoading(true);
    checkDisponibilidadeInscricao(eventoId, distancia.id)
      .then((resp) => {
        if (ativo) setDisponibilidade(resp);
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });
    return () => {
      ativo = false;
    };
  }, [eventoId, distancia.id]);

  const inscritos = disponibilidade.vagasDistancia?.qtdInscrito ?? 0;
  const limite = disponibilidade.vagasDistancia?.qtdLimiteDistancia ?? 0;
  const percentual = limite > 0 ? Math.min(100, (inscritos / limite) * 100) : 0;
  const lotado = limite > 0 && inscritos >= limite;

  return (
    <Box
      sx={{
        minWidth: 168,
        p: 1.75,
        borderRadius: 2,
        border: "1px solid",
        borderColor: lotado ? "error.light" : "grey.200",
        bgcolor: lotado ? "rgba(211, 47, 47, 0.04)" : "background.paper",
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <DirectionsRunOutlinedIcon
          sx={{ fontSize: 18, color: INSCRITOS_ACCENT }}
        />
        <Typography variant="subtitle2" fontWeight={700} noWrap>
          {distancia.descricao}
        </Typography>
      </Box>

      {loading ? (
        <Skeleton variant="rounded" height={36} />
      ) : (
        <>
          <Typography variant="caption" color="text.secondary" display="block" mb={0.75}>
            {inscritos}/{limite || "—"} inscritos
            {limite > 0 ? ` (${percentual.toFixed(0)}%)` : ""}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={percentual}
            sx={{
              height: 8,
              borderRadius: 99,
              bgcolor: INSCRITOS_ACCENT_SOFT,
              "& .MuiLinearProgress-bar": {
                borderRadius: 99,
                bgcolor: lotado ? "error.main" : INSCRITOS_ACCENT,
              },
            }}
          />
        </>
      )}
    </Box>
  );
}
